/**
 * Cert
 */
export interface ICert {
  id: number,
  issuer: string;
  file: any;
}

export const emptyCertificate: ICert = {
  id: -1,
  issuer: '',
  file: '',
};


// WEBPACK FOOTER //
// ./src/app/model/cert.ts